


function getImageURL (url)
{
  return 'https://firebasestorage.googleapis.com/v0/b/' + 'crazytrip-01.appspot.com' + '/o/' + encodeURIComponent(url) + '?alt=media'
}


export {
  getImageURL,
}